import { render, staticRenderFns } from "./FileManagerPage.vue?vue&type=template&id=2df7d20c&"
import script from "./FileManagerPage.vue?vue&type=script&lang=js&"
export * from "./FileManagerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports